module.exports = __webpack_public_path__ + "static/media/Apple Watch 38mm Steel + White Closed.9a0765d2.png";